<template>
  <div
    :class="[
      'loading',
      'loading--' + position,
      'loading--align-x-' + alignX,
      'loading--align-y-' + alignY,
      'loading--height-' + height,
      { 'loading--inverted': inverted },
    ]"
    data-comp="i-loading"
  >
    <div class="dot-elastic"></div>
  </div>
</template>

<script setup>
defineProps({
  alignX: {
    type: String,
    default: "center",
  },
  alignY: {
    type: String,
    default: "center",
  },
  height: {
    type: String,
    default: "100",
  },
  position: {
    type: String,
    default: "fixed",
  },
  inverted: {
    type: Boolean,
    default: false,
  },
});
</script>
<style>
.loading {
  --color-loading: var(--color-purple);
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  z-index: 9;
}

.loading--absolute {
  position: absolute;
}

.loading--relative {
  position: relative;
}

.loading--align-x-start {
  justify-content: flex-start;
}

.loading--align-x-center {
  justify-content: center;
}

.loading--align-x-end {
  justify-content: flex-end;
}

.loading--align-y-start {
  align-items: flex-start;
}

.loading--align-y-center {
  align-items: center;
}

.loading--align-y-end {
  align-items: flex-end;
}

.loading--height-100 {
  height: 100%;
}

.loading--height-75 {
  height: 75vh;
}

.loading--height-auto {
  height: auto;
}

.loading--inverted {
  --color-loading: var(--color-yellow);
}

.dot-elastic {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--color-loading);
  color: var(--color-loading);
  animation: dotElastic 1s 1.5s infinite linear;
  opacity: 0;
}

.dot-elastic::before,
.dot-elastic::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-elastic::before {
  left: -15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--color-loading);
  color: var(--color-loading);
  animation: dotElasticBefore 1s 0.6s infinite linear;
}

.dot-elastic::after {
  left: 15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--color-loading);
  color: var(--color-loading);
  animation: dotElasticAfter 1s 0.6s infinite linear;
}

@keyframes dotElasticBefore {
  0% {
    transform: scale(1, 1);
  }
  1% {
    opacity: 1;
  }
  25% {
    transform: scale(1, 1.5);
  }

  50% {
    transform: scale(1, 0.67);
  }

  75% {
    transform: scale(1, 1);
  }

  100% {
    opacity: 1;
    transform: scale(1, 1);
  }
}

@keyframes dotElastic {
  0% {
    transform: scale(1, 1);
  }
  1% {
    opacity: 1;
  }
  25% {
    transform: scale(1, 1);
  }

  50% {
    transform: scale(1, 1.5);
  }

  75% {
    transform: scale(1, 1);
  }

  100% {
    opacity: 1;
    transform: scale(1, 1);
  }
}

@keyframes dotElasticAfter {
  0% {
    transform: scale(1, 1);
  }
  1% {
    opacity: 1;
  }
  25% {
    transform: scale(1, 1);
  }

  50% {
    transform: scale(1, 0.67);
  }

  75% {
    transform: scale(1, 1.5);
  }

  100% {
    opacity: 1;
    transform: scale(1, 1);
  }
}
</style>
